import React from "react";

import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

import { useStyles } from "./results-table-styles";

//https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
const $ = (value, places = 0) =>
  `$${value.toFixed(places)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

const RaisedPaper = (props) => <Paper {...props} elevation={3} />;

export default ({ age, months }) => {
  const classes = useStyles();

  const thisYear = new Date().getFullYear();

  return (
    <TableContainer className={classes.root} component={RaisedPaper}>
      {/*<Table size="small">*/}
      {/*    <TableHead>*/}
      {/*        <TableRow>*/}
      {/*            <TableCell>*/}
      {/*                Month*/}
      {/*            </TableCell>*/}
      {/*            <TableCell>*/}
      {/*                Capital*/}
      {/*            </TableCell>*/}
      {/*            <TableCell>*/}
      {/*                Profit %*/}
      {/*            </TableCell>*/}
      {/*            <TableCell>*/}
      {/*                Profit*/}
      {/*            </TableCell>*/}
      {/*            <TableCell>*/}
      {/*                Balance*/}
      {/*            </TableCell>*/}
      {/*        </TableRow>*/}
      {/*    </TableHead>*/}
      {/*    <TableBody>*/}
      {/*        {months.map(*/}
      {/*            month => (*/}
      {/*                <TableRow key={month.month}>*/}
      {/*                    <TableCell>*/}
      {/*                        {month.month}*/}
      {/*                    </TableCell>*/}
      {/*                    <TableCell>*/}
      {/*                        {$(month.capital)}*/}
      {/*                    </TableCell>*/}
      {/*                    <TableCell>*/}
      {/*                        {(month.profitPercentage * 100).toFixed(2)}%*/}
      {/*                    </TableCell>*/}
      {/*                    <TableCell>*/}
      {/*                        {$(month.profit)}*/}
      {/*                    </TableCell>*/}
      {/*                    <TableCell>*/}
      {/*                        {$(month.balance)}*/}
      {/*                    </TableCell>*/}
      {/*                </TableRow>*/}
      {/*            )*/}
      {/*        )}*/}
      {/*    </TableBody>*/}
      {/*</Table>*/}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>Через 5 лет</TableCell>
            <TableCell>Через 10 лет</TableCell>
            <TableCell>Через 15 лет</TableCell>
            <TableCell>Через 20 лет</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={classes.optimal}>
            <TableCell>
              Если я начну
              <br />
              сегодня
              <span role="img" aria-label="confident">
                {" "}
                😎
              </span>
            </TableCell>
            <TableCell className={classes.years5}>
              {$(months[5 * 12 - 1].balance)}
            </TableCell>
            <TableCell className={classes.years10}>
              {$(months[10 * 12 - 1].balance)}
            </TableCell>
            <TableCell className={classes.years15}>
              {$(months[15 * 12 - 1].balance)}
            </TableCell>
            <TableCell className={classes.years20}>
              {$(months[20 * 12 - 1].balance)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell />
            <TableCell>
              Через
              <br />5 лет
              <span role="img" aria-label="thinking">
                {" "}
                🤔
              </span>
            </TableCell>
            <TableCell className={classes.years5}>
              {$(months[5 * 12 - 1].balance)}
            </TableCell>
            <TableCell className={classes.years10}>
              {$(months[10 * 12 - 1].balance)}
            </TableCell>
            <TableCell className={classes.years15}>
              {$(months[15 * 12 - 1].balance)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell />
            <TableCell />
            <TableCell>
              Через
              <br />
              10 лет
              <span role="img" aria-label="sad">
                {" "}
                🙄
              </span>
            </TableCell>
            <TableCell className={classes.years5}>
              {$(months[5 * 12 - 1].balance)}
            </TableCell>
            <TableCell className={classes.years10}>
              {$(months[10 * 12 - 1].balance)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell />
            <TableCell />
            <TableCell />
            <TableCell>
              Через
              <br />
              15 лет 😢
            </TableCell>
            <TableCell className={classes.years5}>
              {$(months[5 * 12 - 1].balance)}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <span role="img" aria-label="person">
                🧑{" "}
              </span>
              Мне будет:
            </TableCell>
            <TableCell>{age + 5}</TableCell>
            <TableCell>{age + 10}</TableCell>
            <TableCell>{age + 15}</TableCell>
            <TableCell>{age + 20}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <span role="img" aria-label="calendar">
                📆{" "}
              </span>
              В году:
            </TableCell>
            <TableCell>{thisYear + 5}</TableCell>
            <TableCell>{thisYear + 10}</TableCell>
            <TableCell>{thisYear + 15}</TableCell>
            <TableCell>{thisYear + 20}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
